import React from 'react'
import SplitPage from '@/component/Landmark/SplitPage'
import Sidebar from './component/Sidebar'
import Form from './component/Form'

const RegisterPage = (props) => (
  <SplitPage sidebarContent={<Sidebar />}>
    <Form {...props} />
  </SplitPage>
)

export default RegisterPage
